import { useCallback, useEffect, useState } from "react";
import Home from "./components/Home.jsx";
import Workspace from "./components/Workspace.jsx";
import Toasts from "./components/Toasts.jsx";
import { getRecord, saveRecord } from "./lib/db.js";
import { getCloudFile, resolveCloudShare } from "./lib/cloud.js";

export default function App() {
  const [view, setView] = useState("home");
  const [fileId, setFileId] = useState(null);
  const [initialTool, setInitialTool] = useState(null);
  const [toasts, setToasts] = useState([]);

  const toast = useCallback((message, type = "success") => {
    const id = `${Date.now()}-${Math.random().toString(16).slice(2)}`;
    setToasts((list) => [...list, { id, message, type, onClose: () => setToasts((l) => l.filter((t) => t.id !== id)) }]);
    window.setTimeout(() => setToasts((list) => list.filter((t) => t.id !== id)), 4200);
  }, []);

  useEffect(() => {
    const shareMatch = location.hash.match(/^#s=(.+)$/);
    const localMatch = location.hash.match(/^#local=(.+)$/);
    if (!shareMatch && !localMatch) return;

    let cancelled = false;
    function openLocal(id) {
      getRecord(id)
        .then((record) => {
          if (cancelled) return;
          if (record) {
            setFileId(record.id);
            setInitialTool("share");
            setView("workspace");
          } else {
            toast("分享链接对应的文件已失效或已被删除", "error");
          }
        })
        .catch(() => toast("打开本地分享文件失败", "error"));
    }

    if (localMatch) {
      openLocal(decodeURIComponent(localMatch[1]));
      return undefined;
    }

    const token = decodeURIComponent(shareMatch[1]);
    resolveCloudShare(token)
      .then(async (meta) => {
        const res = await getCloudFile(meta.id);
        const blob = await res.blob();
        const file = new File([blob], meta.name, { type: meta.type || "application/octet-stream" });
        const saved = await saveRecord(file);
        if (!cancelled) {
          setFileId(saved.id);
          setInitialTool("share");
          setView("workspace");
        }
      })
      .catch(() => {
        if (!cancelled) openLocal(token);
      });
    return () => {
      cancelled = true;
    };
  }, [toast]);

  const openFile = useCallback(async (file, tool) => {
    const meta = await saveRecord(file);
    setFileId(meta.id);
    setInitialTool(tool || null);
    setView("workspace");
    return meta;
  }, []);

  const openRecord = useCallback((meta, tool) => {
    setFileId(meta.id);
    setInitialTool(tool || null);
    setView("workspace");
  }, []);

  const goHome = useCallback(() => {
    setView("home");
    setInitialTool(null);
    if (location.hash) history.replaceState(null, "", location.pathname + location.search);
  }, []);

  return (
    <div className="app-shell">
      {view === "home" ? (
        <Home
          onOpen={openRecord}
          onOpenFile={openFile}
          onToast={toast}
        />
      ) : (
        <Workspace
          key={fileId}
          fileId={fileId}
          initialTool={initialTool}
          onBack={goHome}
          onToast={toast}
        />
      )}
      <Toasts toasts={toasts} />
    </div>
  );
}
